import { getCookie } from 'cookies-next'

// twitter cookie get
export function getXcomTwitterClid() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('twclid')) ||
    getCookie('twclid') ||
    null
  )
}
